import React from "react";
import Chart from "react-apexcharts";
import { Card } from "react-bootstrap";

export default function DonationFavoriteAmount({ data = [] }) {
  function getChartOptions() {
    const chartLabel = data.map(({ label }) => label);
    return chartLabel;
  }

  function getDonationFavAmount() {
    const chartDonationAmount = data.map(({ count }) => count.donation_count);
    return chartDonationAmount;
  }

  return (
    <>
      <Card>
        <Card.Header>
          <h4>Nominal Donasi Favorit</h4>
        </Card.Header>
        <Card.Body>
          <Chart
            options={{
              chart: {
                id: "basic-bar"
              },
              xaxis: {
                categories: getChartOptions()
              }
            }}
            series={[
              {
                name: "Jumlah Donasi",
                data: getDonationFavAmount()
              }
            ]}
            type="bar"
            height="300"
          />
        </Card.Body>
      </Card>
    </>
  );
}
